export type ImageCategory = "activity" | "vote" | "landing" | "general" | "news";

export const IMAGE_CATEGORY_LABELS: Record<ImageCategory, string> = {
  activity: "活动封面",
  vote: "投票封面",
  landing: "落地页背景",
  general: "通用素材",
  news: "资讯封面",
};

export interface LibraryImage {
  id: string;
  url: string;
  name: string;
  category: ImageCategory;
  uploadedAt: string;
  isLocal?: boolean;
}
